import styled, { keyframes, css } from 'styled-components';
import { colors, transparentColors } from '../../variables/colors.js';
import { deviceWidths } from '../../variables/widths.js';
import { transitions } from '../../variables/transitions.js';

var tooltipArrowWidth = '6px';
var tooltipArrowHeight = '8px';
var tooltipZIndex = 999;
var closeButtonZIndex = 1000;
var fadeOutAndHide = keyframes(["0%{opacity:1;visibility:visible;}100%{opacity:0;visibility:hidden;}"]);
var Tooltip = styled.div.withConfig({
  displayName: "style__Tooltip",
  componentId: "sc-i8jgn-0"
})(["color:", ";font-size:14px;margin:0;position:relative;text-align:center;transform:translate3d(0,0,0);width:100%;"], colors.lightGrayL1);
var CloseButton = styled.button.withConfig({
  displayName: "style__CloseButton",
  componentId: "sc-i8jgn-1"
})(["fill:", ";position:absolute;right:7px;top:14px;z-index:", ";"], colors.white, closeButtonZIndex);
var Popover = styled.div.withConfig({
  displayName: "style__Popover",
  componentId: "sc-i8jgn-2"
})(["background:", ";border-radius:3px;box-sizing:border-box;line-height:18px;min-width:100%;padding:8px;position:absolute;top:calc(", " - 1px);z-index:", ";", " &::before{border-color:transparent transparent ", ";border-style:solid;border-width:0 ", " ", ";content:'';height:0;left:calc(50% - ", ");position:absolute;top:-", ";width:0;", "  ", " ", "}@media (min-width:", "){", "}"], transparentColors.semiTransparentblack80, tooltipArrowHeight, tooltipZIndex, function (props) {
  return props.hasCloseFunc && css(["padding:16px 32px;"]);
}, transparentColors.semiTransparentblack80, tooltipArrowWidth, tooltipArrowHeight, tooltipArrowWidth, tooltipArrowHeight, function (props) {
  return props.arrowHorizontalPosition === 'left' && css(["left:calc(20% - ", ");"], tooltipArrowWidth);
}, function (props) {
  return props.arrowHorizontalPosition === 'right' && css(["left:calc(80% - ", ");"], tooltipArrowWidth);
}, function (props) {
  return props.arrowVerticalPosition === 'bottom' && css(["bottom:-", ";top:auto;transform:rotate(180deg);"], tooltipArrowHeight);
}, deviceWidths.tabletMax, function (props) {
  return props.autofade && css(["animation:", " ", ";animation-delay:4s;animation-fill-mode:forwards;"], fadeOutAndHide, transitions.transitionSpeeds["default"]);
});

export { CloseButton, Popover, Tooltip };
//# sourceMappingURL=style.js.map
